import { db, firebase } from "../../../config/firebase/firebase-config";
import { IValidateProductionOffice } from "../../admin/form/IValidateProductionOffice";
import { IAuditDoc } from "../doc/IAuditDoc";

// Agregar oficina productora para auditoria
export const deleteProductionOfficeAudit = async (
  value: IValidateProductionOffice,
  office: any,
  audit: IAuditDoc
) => {
  try {
    await db
      .collection("Entities")
      .doc(audit.idEntity)
      .collection("Audit")
      .doc("ProductionOffices")
      .collection("ProductionOffices")
      .doc(value.idProductionOffice)
      .set(office, { merge: true });

    const auditRef = await db
      .collection("Entities")
      .doc(value.idEntity)
      .collection("Audit")
      .doc("ProductionOffices")
      .collection("ProductionOffices")
      .doc(value.idProductionOffice)
      .collection("Audit")
      .doc();

    audit.id = auditRef.id;

    await auditRef.set(audit);

    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

// Agregar usuario para auditoria
export const deleteUserAudit = async (user: any, audit: IAuditDoc) => {
  try {
    await db
      .collection("Entities")
      .doc(audit.idEntity)
      .collection("Audit")
      .doc("User")
      .collection("User")
      .doc(user.id)
      .set(user, { merge: true });

    const auditRef = await db
      .collection("Entities")
      .doc(user.idEntity)
      .collection("Audit")
      .doc("User")
      .collection("User")
      .doc(user.id)
      .collection("Audit")
      .doc();

    audit.id = auditRef.id;

    await auditRef.set(audit);

    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

// Agregar oficina para auditoria
export const deleteOfficeAudit = async (office: any, audit: IAuditDoc) => {
  try {
    await db
      .collection("Entities")
      .doc(audit.idEntity)
      .collection("Audit")
      .doc("ProductionOffices")
      .collection("ProductionOffices")
      .doc(office.idProductionOffice)
      .collection("Offices")
      .doc(office.idOffice)
      .set(office, { merge: true });

    const auditRef = await db
      .collection("Entities")
      .doc(audit.idEntity)
      .collection("Audit")
      .doc("ProductionOffices")
      .collection("ProductionOffices")
      .doc(office.idProductionOffice)
      .collection("Offices")
      .doc(office.idOffice)
      .collection("Audit")
      .doc();

    audit.id = auditRef.id;

    await auditRef.set(audit);

    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

// Agregar oficina para auditoria
export const deleteSerieAudit = async (serieData: any, audit: IAuditDoc) => {
  try {
    await db
      .collection("Entities")
      .doc(audit.idEntity)
      .collection("Audit")
      .doc("Serie")
      .collection("Serie")
      .doc(serieData.idSerie)
      .set(serieData, { merge: true });

    //agrega la nueva accion a eliminar
    const auditRef = await db
      .collection("Entities")
      .doc(audit.idEntity)
      .collection("Audit")
      .doc("Serie")
      .collection("Serie")
      .doc(serieData.idSerie)
      .collection("Audit")
      .doc();

    audit.id = auditRef.id;

    await auditRef.set(audit);

    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};
